import { InsertData } from "../../Hooks/InsertData";
import {
  UPDATE_USER_PROFILE,
  CREATE_NEW_USER,

  FOREGT_PASSWORD,
  GET_CURERNT_USER,
  LOGIN_USER,
} from "../type";
import { InsUpdateData } from "../../Hooks/UpdataData";
import { GetDataToken } from "../../Hooks/getAllData";
//create new user
export const createNewUserAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/Account/Register`, data);
    dispatch({
      type: CREATE_NEW_USER,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: CREATE_NEW_USER,
      payload: e.response,
    });
  }
};

//login  user
export const loginUserAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/Account/Login`, data);
    dispatch({
      type: LOGIN_USER,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: LOGIN_USER,
      payload: e.response,
    });
  }
};

//login  user
export const getLoggedUserAction = () => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/Account/GetMyProfile`);
    dispatch({
      type: GET_CURERNT_USER,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_CURERNT_USER,
      payload: e.response,
    });
  }
};

export const forgetPasswordAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/ContactUs/ForgotPassword`, data);
    dispatch({
      type: FOREGT_PASSWORD,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: FOREGT_PASSWORD,
      payload: e.response,
    });
  }
};

// //2-verify  passwrod
// export const verifyPasswordAction = (data) => async (dispatch) => {
//   try {
//     const response = await InsertData(`/api/v1/auth/verifyResetCode`, data);
//     dispatch({
//       type: VERIFY_PASSWORD,
//       payload: response,
//       loading: true,
//     });
//   } catch (e) {
//     dispatch({
//       type: VERIFY_PASSWORD,
//       payload: e.response,
//     });
//   }
// };

// //2-reset  passwrod
// export const resetPasswordAction = (data) => async (dispatch) => {
//   try {
//     const response = await InsUpdateData(`/api/v1/auth/resetPassword`, data);
//     dispatch({
//       type: RESET_PASSWORD,
//       payload: response,
//       loading: true,
//     });
//   } catch (e) {
//     dispatch({
//       type: RESET_PASSWORD,
//       payload: e.response,
//     });
//   }
// };

//update  user data
export const updateUserProfileDataAction = (body) => async (dispatch) => {
  try {
    const response = await InsUpdateData(`/api/Account/UpdateProfile`, body);
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_USER_PROFILE,
      payload: e.response,
    });
  }
};

// //update  user password
// export const updateUserPasswordAction = (body) => async (dispatch) => {
//   try {
//     const response = await InsUpdateData(
//       `/api/v1/users/changeMyPassword`,
//       body
//     );
//     dispatch({
//       type: UPDATE_USER_PASSWORD,
//       payload: response,
//       loading: true,
//     });
//   } catch (e) {
//     dispatch({
//       type: UPDATE_USER_PASSWORD,
//       payload: e.response,
//     });
//   }
// };
